export interface Movie {
  id: string;
  title: string;
  type: "movie" | "tv";
  genre: string[];
  region: string;
  year: number;
  rating: number;
  duration: string;
  director: string;
  cast: string[];
  synopsis: string;
  poster: string;
  backdrop: string;
  tags: string[];
  popularity: number;
  releaseDate: string;
}

export const movies: Movie[] = [
  {
    id: "1001",
    title: "长夜将尽",
    type: "movie",
    genre: ["剧情", "悬疑"],
    region: "中国大陆",
    year: 2024,
    rating: 8.7,
    duration: "128 分钟",
    director: "陆承舟",
    cast: ["沈砚", "许清和", "林知白", "周迟"],
    synopsis:
      "一名退役刑警在雨夜重返旧案现场，随着线索层层剥开，他发现真相远比想象中更接近自己。影片以冷峻的镜头语言探讨人性与救赎，在漫长黑夜中等待第一束光。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20art%20of%20a%20lone%20detective%20silhouette%20under%20a%20rain%20soaked%20streetlamp%20in%20a%20dark%20city%20at%20midnight%2C%20deep%20navy%20blue%20tones%20with%20a%20single%20warm%20orange%20glow%2C%20noir%20atmosphere%2C%20dramatic%20lighting%2C%20film%20grain%2C%20vertical%20composition&width=400&height=600&seq=qx-poster-1001&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20backdrop%20of%20a%20rainy%20neon%20lit%20city%20street%20at%20night%2C%20deep%20navy%20blue%20and%20moody%20tones%20with%20warm%20orange%20reflections%20on%20wet%20asphalt%2C%20atmospheric%20fog%2C%20dramatic%20noir%20lighting&width=1600&height=900&seq=qx-backdrop-1001&orientation=landscape",
    tags: ["悬疑推理", "人性救赎", "雨夜"],
    popularity: 9820,
    releaseDate: "2024-03-15",
  },
  {
    id: "1002",
    title: "星海迷航",
    type: "movie",
    genre: ["科幻", "冒险"],
    region: "中国大陆",
    year: 2023,
    rating: 8.2,
    duration: "142 分钟",
    director: "苏远航",
    cast: ["江屿", "柯以宁", "傅寒川", "叶知夏"],
    synopsis:
      "一支深空探索队在未知星系失联，唯一的幸存者必须穿越星海裂缝带回真相。宏大的宇宙奇观与细腻的情感刻画交织，讲述人类在浩瀚宇宙中的渺小与倔强。",
    poster:
      "https://readdy.ai/api/search-image?query=Science%20fiction%20movie%20poster%20showing%20a%20lone%20astronaut%20facing%20a%20vast%20glowing%20nebula%20and%20swirling%20galaxy%2C%20deep%20blue%20cosmos%20with%20bright%20orange%20stellar%20core%2C%20epic%20scale%2C%20dramatic%20rim%20lighting%2C%20high%20detail%20vertical%20composition&width=400&height=600&seq=qx-poster-1002&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Epic%20wide%20space%20backdrop%20of%20a%20spaceship%20sailing%20past%20a%20giant%20ringed%20planet%20and%20colorful%20nebula%20clouds%2C%20deep%20navy%20blue%20with%20glowing%20orange%20accents%2C%20cinematic%20sci%20fi%20atmosphere%2C%20starlight&width=1600&height=900&seq=qx-backdrop-1002&orientation=landscape",
    tags: ["太空探索", "硬核科幻", "视觉奇观"],
    popularity: 8640,
    releaseDate: "2023-09-01",
  },
  {
    id: "1003",
    title: "山河故人梦",
    type: "movie",
    genre: ["剧情", "历史"],
    region: "中国大陆",
    year: 2022,
    rating: 8.9,
    duration: "156 分钟",
    director: "贾望川",
    cast: ["程砚秋", "白景行", "宋亦真", "孟怀远"],
    synopsis:
      "跨越三代人的家族史，在时代洪流中书写普通人的坚守与离别。一纸家书、一座老院、一条奔腾的河，串联起关于土地与根脉的深沉记忆。",
    poster:
      "https://readdy.ai/api/search-image?query=Literary%20historical%20movie%20poster%20of%20a%20solitary%20figure%20standing%20before%20a%20flowing%20river%20and%20misty%20mountains%20at%20dusk%2C%20muted%20indigo%20blue%20tones%20with%20warm%20amber%20sunset%20accent%2C%20painterly%20textured%20style%2C%20vertical%20composition&width=400&height=600&seq=qx-poster-1003&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Sweeping%20historical%20landscape%20backdrop%20of%20layered%20mountains%20and%20a%20wide%20river%20under%20a%20dramatic%20dusk%20sky%2C%20deep%20blue%20and%20muted%20orange%20gradient%2C%20cinematic%20epic%20mood%2C%20soft%20mist&width=1600&height=900&seq=qx-backdrop-1003&orientation=landscape",
    tags: ["年代", "家族史诗", "人文"],
    popularity: 9130,
    releaseDate: "2022-11-18",
  },
  {
    id: "1004",
    title: "无声证词",
    type: "movie",
    genre: ["悬疑", "犯罪"],
    region: "中国香港",
    year: 2024,
    rating: 8.5,
    duration: "118 分钟",
    director: "陈启铭",
    cast: ["何子谦", "容雅仪", "麦嘉俊", "关雪晴"],
    synopsis:
      "法医在一宗看似完美的自杀案中发现细微破绽，随着解剖刀下的真相浮出水面，一张精心编织的谎言网被逐层撕开。冷静克制的叙事，步步紧逼的推理。",
    poster:
      "https://readdy.ai/api/search-image?query=Crime%20thriller%20movie%20poster%20of%20a%20forensic%20lightbox%20and%20evidence%20photos%20in%20a%20dark%20room%2C%20cold%20steel%20blue%20tones%20with%20a%20sharp%20orange%20highlight%2C%20clinical%20tense%20mood%2C%20dramatic%20shadows%2C%20vertical%20composition&width=400&height=600&seq=qx-poster-1004&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20moody%20crime%20investigation%20backdrop%20of%20a%20dimly%20lit%20forensic%20lab%20with%20glass%20and%20steel%20surfaces%2C%20cool%20blue%20tones%20with%20orange%20accent%20light%2C%20cinematic%20suspense%20atmosphere&width=1600&height=900&seq=qx-backdrop-1004&orientation=landscape",
    tags: ["法医", "高智商犯罪", "港片质感"],
    popularity: 8090,
    releaseDate: "2024-06-20",
  },
  {
    id: "1005",
    title: "追风少年",
    type: "movie",
    genre: ["青春", "运动"],
    region: "中国大陆",
    year: 2023,
    rating: 7.8,
    duration: "112 分钟",
    director: "李牧野",
    cast: ["许星河", "温以宁", "秦朗", "苏晚"],
    synopsis:
      "一群小镇少年为了心中的赛道梦想，在质疑与汗水中逆风奔跑。热血、友情与成长交织，讲述普通人如何把不可能变成可能。",
    poster:
      "https://readdy.ai/api/search-image?query=Youthful%20sports%20movie%20poster%20of%20a%20young%20runner%20sprinting%20on%20an%20open%20track%20at%20sunrise%2C%20energetic%20blue%20sky%20with%20vibrant%20orange%20sunlight%20flares%2C%20dynamic%20motion%2C%20inspiring%20upbeat%20mood%2C%20vertical%20composition&width=400&height=600&seq=qx-poster-1005&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20sunrise%20athletics%20stadium%20backdrop%20with%20warm%20golden%20orange%20light%20and%20deep%20blue%20morning%20sky%2C%20cinematic%20sports%20drama%20mood%2C%20energetic%20and%20hopeful&width=1600&height=900&seq=qx-backdrop-1005&orientation=landscape",
    tags: ["热血", "成长", "励志"],
    popularity: 6720,
    releaseDate: "2023-07-08",
  },
  {
    id: "1006",
    title: "深蓝之约",
    type: "movie",
    genre: ["爱情", "剧情"],
    region: "中国台湾",
    year: 2022,
    rating: 8.1,
    duration: "124 分钟",
    director: "林语柔",
    cast: ["郭以安", "简若薇", "吴承翰"],
    synopsis:
      "两个在海岸小镇相遇的陌生人，用一个夏天的约定改变了彼此的人生。温柔克制的爱情叙事，在潮起潮落间缓缓展开。",
    poster:
      "https://readdy.ai/api/search-image?query=Romantic%20drama%20movie%20poster%20of%20two%20silhouettes%20standing%20on%20a%20quiet%20beach%20watching%20a%20soft%20sunset%20over%20the%20sea%2C%20deep%20ocean%20blue%20with%20gentle%20peach%20orange%20glow%2C%20dreamy%20soft%20focus%2C%20vertical%20composition&width=400&height=600&seq=qx-poster-1006&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20serene%20seaside%20backdrop%20at%20golden%20hour%20with%20calm%20ocean%2C%20soft%20blue%20water%20and%20warm%20orange%20sunset%20reflections%2C%20dreamy%20romantic%20cinematic%20mood&width=1600&height=900&seq=qx-backdrop-1006&orientation=landscape",
    tags: ["治愈", "海边", "慢叙事"],
    popularity: 7410,
    releaseDate: "2022-08-12",
  },
  {
    id: "1007",
    title: "破晓行动",
    type: "movie",
    genre: ["动作", "战争"],
    region: "中国大陆",
    year: 2024,
    rating: 8.3,
    duration: "134 分钟",
    director: "高子龙",
    cast: ["雷震霆", "宋建国", "方沐", "吕铮"],
    synopsis:
      "一支特遣小队深入敌后执行绝密任务，在黎明前的黑暗中用血肉之躯守护身后万家灯火。紧张窒息的战术场面与家国情怀交织。",
    poster:
      "https://readdy.ai/api/search-image?query=Action%20war%20movie%20poster%20of%20silhouetted%20soldiers%20advancing%20through%20smoke%20toward%20a%20rising%20sun%2C%20gritty%20dark%20blue%20tones%20with%20fierce%20orange%20explosion%20glow%2C%20intense%20dramatic%20lighting%2C%20vertical%20composition&width=400&height=600&seq=qx-poster-1007&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20war%20movie%20backdrop%20of%20a%20battlefield%20at%20dawn%20with%20smoke%20and%20distant%20orange%20flare%20light%20against%20a%20deep%20blue%20sky%2C%20gritty%20cinematic%20tension&width=1600&height=900&seq=qx-backdrop-1007&orientation=landscape",
    tags: ["军事", "兄弟情", "大场面"],
    popularity: 8870,
    releaseDate: "2024-01-26",
  },
  {
    id: "1008",
    title: "时光信笺",
    type: "movie",
    genre: ["爱情", "奇幻"],
    region: "韩国",
    year: 2021,
    rating: 8.6,
    duration: "116 分钟",
    director: "金敏浩",
    cast: ["朴志勋", "韩素妍", "李泰成"],
    synopsis:
      "一封能寄往过去的神秘信笺，让错过的两个人重新拥有一次选择的机会。关于时间、遗憾与重逢的温柔幻想。",
    poster:
      "https://readdy.ai/api/search-image?query=Fantasy%20romance%20movie%20poster%20of%20glowing%20envelope%20letters%20floating%20in%20a%20starry%20night%20sky%20above%20a%20quiet%20town%2C%20deep%20indigo%20blue%20with%20warm%20amber%20light%20specks%2C%20dreamlike%20ethereal%20mood%2C%20vertical%20composition&width=400&height=600&seq=qx-poster-1008&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20dreamy%20backdrop%20of%20a%20town%20under%20a%20vast%20starry%20night%20sky%20with%20soft%20glowing%20lights%2C%20deep%20blue%20palette%20with%20warm%20orange%20lantern%20glow%2C%20magical%20cinematic%20mood&width=1600&height=900&seq=qx-backdrop-1008&orientation=landscape",
    tags: ["时空", "催泪", "唯美"],
    popularity: 7950,
    releaseDate: "2021-12-03",
  },
  {
    id: "1009",
    title: "雾都疑云",
    type: "movie",
    genre: ["悬疑", "惊悚"],
    region: "英国",
    year: 2023,
    rating: 8.4,
    duration: "122 分钟",
    director: "Oliver Grant",
    cast: ["Ethan Clarke", "Sophie Hale", "Marcus Reid"],
    synopsis:
      "浓雾笼罩的伦敦街头，一连串离奇失踪案指向一个被尘封的秘密。侦探在蛛丝马迹中追逐真相，却发现自己早已身处局中。",
    poster:
      "https://readdy.ai/api/search-image?query=Mystery%20thriller%20movie%20poster%20of%20a%20coated%20detective%20walking%20through%20thick%20London%20fog%20with%20dim%20streetlamps%2C%20muted%20slate%20blue%20tones%20with%20a%20warm%20orange%20lamp%20glow%2C%20eerie%20atmospheric%20mood%2C%20vertical%20composition&width=400&height=600&seq=qx-poster-1009&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20foggy%20Victorian%20London%20street%20backdrop%20at%20night%20with%20glowing%20gas%20lamps%2C%20cool%20blue%20grey%20tones%20with%20warm%20orange%20light%20pools%2C%20mysterious%20cinematic%20mood&width=1600&height=900&seq=qx-backdrop-1009&orientation=landscape",
    tags: ["英伦", "推理", "氛围向"],
    popularity: 7320,
    releaseDate: "2023-10-13",
  },
  {
    id: "1010",
    title: "荒野回声",
    type: "movie",
    genre: ["冒险", "剧情"],
    region: "美国",
    year: 2022,
    rating: 7.9,
    duration: "138 分钟",
    director: "Daniel Brooks",
    cast: ["Ryan Carter", "Emma Lawson", "Jack Morrow"],
    synopsis:
      "一场意外的荒野迷失，让一对父女在绝境中重新认识彼此。广袤自然的壮美与人类情感的坚韧交织成一曲生命之歌。",
    poster:
      "https://readdy.ai/api/search-image?query=Adventure%20drama%20movie%20poster%20of%20two%20hikers%20standing%20on%20a%20cliff%20edge%20overlooking%20a%20vast%20canyon%20at%20sunrise%2C%20deep%20blue%20mountains%20with%20warm%20orange%20golden%20light%2C%20sweeping%20epic%20mood%2C%20vertical%20composition&width=400&height=600&seq=qx-poster-1010&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20epic%20wilderness%20backdrop%20of%20a%20deep%20canyon%20and%20pine%20forest%20at%20golden%20hour%2C%20rich%20blue%20shadows%20with%20warm%20orange%20sunlight%2C%20cinematic%20adventure%20grandeur&width=1600&height=900&seq=qx-backdrop-1010&orientation=landscape",
    tags: ["自然", "亲情", "生存"],
    popularity: 6580,
    releaseDate: "2022-05-27",
  },
  {
    id: "1011",
    title: "东京的雨",
    type: "movie",
    genre: ["爱情", "文艺"],
    region: "日本",
    year: 2023,
    rating: 8.0,
    duration: "108 分钟",
    director: "佐藤悠真",
    cast: ["山田悠人", "小林美咲", "中村拓真"],
    synopsis:
      "一家深夜营业的旧书店，一场连绵不断的梅雨，一段若有似无的心动。安静文艺的影像风格，记录城市里最细腻的相遇与告别。",
    poster:
      "https://readdy.ai/api/search-image?query=Art%20house%20romance%20movie%20poster%20of%20a%20person%20holding%20a%20clear%20umbrella%20in%20a%20narrow%20rainy%20Tokyo%20alley%20at%20night%2C%20soft%20blue%20rain%20tones%20with%20warm%20orange%20window%20light%2C%20quiet%20poetic%20mood%2C%20vertical%20composition&width=400&height=600&seq=qx-poster-1011&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20rainy%20night%20Tokyo%20backdrop%20of%20a%20narrow%20alley%20with%20glowing%20lanterns%20and%20puddles%2C%20cool%20blue%20rain%20tones%20with%20warm%20orange%20signage%20glow%2C%20cinematic%20quiet%20mood&width=1600&height=900&seq=qx-backdrop-1011&orientation=landscape",
    tags: ["日系", "文艺", "慢节奏"],
    popularity: 7010,
    releaseDate: "2023-04-21",
  },
  {
    id: "1012",
    title: "最后的棋局",
    type: "movie",
    genre: ["剧情", "传记"],
    region: "中国大陆",
    year: 2021,
    rating: 8.8,
    duration: "130 分钟",
    director: "钟启明",
    cast: ["秦致远", "陆文博", "司马青", "孟若水"],
    synopsis:
      "一位年迈的棋坛宗师在人生的最后一盘棋中，回望荣耀与遗憾交织的一生。棋盘之上，落子无悔，人生亦然。",
    poster:
      "https://readdy.ai/api/search-image?query=Biographical%20drama%20movie%20poster%20of%20an%20elderly%20mans%20hand%20placing%20a%20go%20stone%20on%20a%20wooden%20board%20under%20warm%20light%2C%20deep%20blue%20shadow%20background%20with%20amber%20orange%20glow%2C%20contemplative%20dignified%20mood%2C%20vertical%20composition&width=400&height=600&seq=qx-poster-1012&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20backdrop%20of%20a%20traditional%20study%20with%20a%20go%20board%20and%20warm%20lantern%20light%2C%20deep%20blue%20shadows%20and%20amber%20orange%20highlights%2C%20refined%20quiet%20atmosphere&width=1600&height=900&seq=qx-backdrop-1012&orientation=landscape",
    tags: ["围棋", "人生", "匠心"],
    popularity: 9060,
    releaseDate: "2021-09-17",
  },
  {
    id: "2001",
    title: "长安十二时",
    type: "tv",
    genre: ["古装", "悬疑"],
    region: "中国大陆",
    year: 2023,
    rating: 9.0,
    duration: "全 40 集",
    director: "顾长风",
    cast: ["裴少卿", "苏明薇", "江无涯", "柳如烟"],
    synopsis:
      "繁华长安城在十二个时辰内暗流涌动，一位小官吏与同伴们必须在宵禁前阻止一场惊天阴谋。紧张倒计时叙事与东方美学场景相得益彰。",
    poster:
      "https://readdy.ai/api/search-image?query=Ancient%20Chinese%20drama%20poster%20of%20a%20robed%20scholar%20standing%20on%20a%20lantern%20lit%20palace%20bridge%20at%20night%2C%20deep%20blue%20and%20rich%20orange%20lantern%20glow%2C%20oriental%20ink%20painting%20style%2C%20epic%20vertical%20composition&width=400&height=600&seq=qx-poster-2001&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20ancient%20Chinese%20city%20backdrop%20at%20night%20with%20towering%20palace%20gates%20and%20countless%20glowing%20lanterns%2C%20deep%20blue%20sky%20with%20warm%20orange%20light%2C%20cinematic%20epic%20mood&width=1600&height=900&seq=qx-backdrop-2001&orientation=landscape",
    tags: ["古装权谋", "倒计时", "东方美学"],
    popularity: 9960,
    releaseDate: "2023-02-10",
  },
  {
    id: "2002",
    title: "都市浮生记",
    type: "tv",
    genre: ["都市", "情感"],
    region: "中国大陆",
    year: 2024,
    rating: 8.2,
    duration: "全 32 集",
    director: "方晓阳",
    cast: ["顾承宇", "白雨晴", "周一凡", "林筱筱"],
    synopsis:
      "四个人、一座城、无数个深夜加班后的抉择。剧集以细腻笔触描绘都市青年的理想、迷茫与相互取暖，真实而有温度。",
    poster:
      "https://readdy.ai/api/search-image?query=Modern%20urban%20drama%20poster%20of%20young%20professionals%20standing%20on%20a%20high%20rise%20rooftop%20overlooking%20a%20city%20skyline%20at%20dusk%2C%20deep%20blue%20with%20warm%20orange%20city%20lights%2C%20clean%20contemporary%20mood%2C%20vertical%20composition&width=400&height=600&seq=qx-poster-2002&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20modern%20city%20skyline%20backdrop%20at%20blue%20hour%20with%20glowing%20windows%20and%20warm%20orange%20street%20lights%2C%20urban%20cinematic%20mood%2C%20clean%20and%20stylish&width=1600&height=900&seq=qx-backdrop-2002&orientation=landscape",
    tags: ["都市情感", "群像", "现实题材"],
    popularity: 8120,
    releaseDate: "2024-05-06",
  },
  {
    id: "2003",
    title: "迷雾追凶",
    type: "tv",
    genre: ["犯罪", "悬疑"],
    region: "中国大陆",
    year: 2023,
    rating: 8.7,
    duration: "全 36 集",
    director: "阎立诚",
    cast: ["关靖", "万晴", "霍东", "纪然"],
    synopsis:
      "一桩跨越十年的连环案重新启动调查，执着的老刑警与敏锐的新搭档在层层迷雾中逼近真相。节奏紧凑，反转不断。",
    poster:
      "https://readdy.ai/api/search-image?query=Crime%20series%20poster%20of%20a%20detective%20examining%20a%20case%20map%20with%20photos%20in%20a%20dark%20office%2C%20cold%20blue%20tones%20with%20a%20sharp%20orange%20pin%20highlight%2C%20gritty%20investigative%20mood%2C%20vertical%20composition&width=400&height=600&seq=qx-poster-2003&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20crime%20investigation%20backdrop%20of%20a%20rainy%20city%20at%20night%20with%20police%20car%20lights%20and%20fog%2C%20deep%20blue%20tones%20with%20orange%20flashes%2C%20cinematic%20tension&width=1600&height=900&seq=qx-backdrop-2003&orientation=landscape",
    tags: ["刑侦", "连环案", "强反转"],
    popularity: 8710,
    releaseDate: "2023-08-15",
  },
  {
    id: "2004",
    title: "急诊先锋",
    type: "tv",
    genre: ["医疗", "职场"],
    region: "中国大陆",
    year: 2022,
    rating: 8.4,
    duration: "全 30 集",
    director: "沈国栋",
    cast: ["严昭", "苏念", "程野", "康乐"],
    synopsis:
      "急诊科的每一秒都是与死神的赛跑。一群年轻医护在高压环境中坚守初心，用专业与温情守护每一个生命。",
    poster:
      "https://readdy.ai/api/search-image?query=Medical%20drama%20poster%20of%20a%20doctor%20in%20scrubs%20standing%20in%20a%20bright%20emergency%20room%20corridor%2C%20clean%20blue%20tones%20with%20warm%20orange%20light%20accents%2C%20hopeful%20professional%20mood%2C%20vertical%20composition&width=400&height=600&seq=qx-poster-2004&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20modern%20hospital%20emergency%20room%20backdrop%20with%20clean%20corridors%20and%20soft%20lighting%2C%20cool%20blue%20tones%20with%20warm%20orange%20accents%2C%20clinical%20cinematic%20mood&width=1600&height=900&seq=qx-backdrop-2004&orientation=landscape",
    tags: ["医疗职场", "群像", "正能量"],
    popularity: 7680,
    releaseDate: "2022-06-28",
  },
  {
    id: "2005",
    title: "王座风云",
    type: "tv",
    genre: ["奇幻", "权谋"],
    region: "美国",
    year: 2023,
    rating: 8.9,
    duration: "全 24 集",
    director: "Andrew Sterling",
    cast: ["Nathan Cole", "Isabella Reed", "Oliver Hayes"],
    synopsis:
      "在分裂的七大王座之间，权谋、背叛与魔法交织。一个普通少女意外卷入王位之争，命运的天平开始倾斜。史诗级奇幻巨制。",
    poster:
      "https://readdy.ai/api/search-image?query=Fantasy%20epic%20series%20poster%20of%20a%20lone%20figure%20standing%20before%20a%20looming%20throne%20in%20a%20great%20hall%2C%20deep%20blue%20shadows%20with%20glowing%20orange%20torchlight%2C%20dramatic%20regal%20mood%2C%20vertical%20composition&width=400&height=600&seq=qx-poster-2005&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20epic%20fantasy%20backdrop%20of%20a%20vast%20stone%20castle%20on%20a%20cliff%20under%20a%20stormy%20blue%20sky%20with%20warm%20orange%20braziers%2C%20grand%20cinematic%20scale&width=1600&height=900&seq=qx-backdrop-2005&orientation=landscape",
    tags: ["史诗奇幻", "权谋", "大制作"],
    popularity: 9340,
    releaseDate: "2023-03-24",
  },
  {
    id: "2006",
    title: "人间烟火",
    type: "tv",
    genre: ["家庭", "治愈"],
    region: "中国台湾",
    year: 2021,
    rating: 8.5,
    duration: "全 26 集",
    director: "许静文",
    cast: ["阿德", "陈淑芬", "林小满"],
    synopsis:
      "一家开了三十年的面馆，煮尽了邻里街坊的悲欢离合。温柔治愈的日常故事，让人重新相信平凡生活里的温度。",
    poster:
      "https://readdy.ai/api/search-image?query=Warm%20family%20drama%20poster%20of%20a%20cozy%20noodle%20shop%20at%20dusk%20with%20steam%20rising%20and%20a%20glowing%20lantern%2C%20soft%20blue%20evening%20tones%20with%20warm%20orange%20interior%20light%2C%20heartwarming%20mood%2C%20vertical%20composition&width=400&height=600&seq=qx-poster-2006&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20cozy%20old%20street%20in%20a%20Taiwanese%20town%20at%20dusk%20with%20warm%20glowing%20shops%2C%20soft%20blue%20evening%20light%20with%20orange%20lamps%2C%20nostalgic%20cinematic%20warmth&width=1600&height=900&seq=qx-backdrop-2006&orientation=landscape",
    tags: ["家庭治愈", "美食", "温情"],
    popularity: 7290,
    releaseDate: "2021-10-08",
  },
  {
    id: "2007",
    title: "星火燎原",
    type: "tv",
    genre: ["年代", "战争"],
    region: "中国大陆",
    year: 2022,
    rating: 9.1,
    duration: "全 44 集",
    director: "谭建国",
    cast: ["贺远山", "甄有义", "苏芷兰", "方铁柱"],
    synopsis:
      "在动荡年代，一群怀揣理想的青年从微末中崛起，用信念点燃希望之火。气势恢宏的年代叙事，刻画小人物的大时代。",
    poster:
      "https://readdy.ai/api/search-image?query=Period%20war%20drama%20poster%20of%20determined%20young%20people%20standing%20against%20a%20vast%20sky%20with%20sparks%20rising%2C%20deep%20blue%20tones%20with%20fierce%20orange%20flame%20light%2C%20heroic%20epic%20mood%2C%20vertical%20composition&width=400&height=600&seq=qx-poster-2007&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20historic%20battlefield%20dawn%20backdrop%20with%20smoke%20and%20distant%20orange%20firelight%20under%20a%20deep%20blue%20sky%2C%20epic%20cinematic%20grandeur&width=1600&height=900&seq=qx-backdrop-2007&orientation=landscape",
    tags: ["年代剧", "热血", "家国情怀"],
    popularity: 9580,
    releaseDate: "2022-01-14",
  },
  {
    id: "2008",
    title: "重生之刃",
    type: "tv",
    genre: ["科幻", "动作"],
    region: "韩国",
    year: 2024,
    rating: 8.3,
    duration: "全 20 集",
    director: "崔东勋",
    cast: ["郑宇成", "韩智恩", "朴振浩"],
    synopsis:
      "一名特工在死亡边缘获得了重置时间的能力，为了阻止灾难，他必须一次次深入险境。高概念设定与凌厉动作场面完美结合。",
    poster:
      "https://readdy.ai/api/search-image?query=Cyberpunk%20action%20series%20poster%20of%20a%20shadowy%20agent%20with%20glowing%20digital%20circuits%20on%20a%20dark%20city%20rooftop%2C%20deep%20blue%20neon%20tones%20with%20bright%20orange%20glow%2C%20high%20tech%20sleek%20mood%2C%20vertical%20composition&width=400&height=600&seq=qx-poster-2008&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20cyberpunk%20city%20backdrop%20at%20night%20with%20neon%20lights%20and%20rain%2C%20deep%20blue%20tones%20with%20vivid%20orange%20glow%2C%20sleek%20high%20tech%20cinematic%20mood&width=1600&height=900&seq=qx-backdrop-2008&orientation=landscape",
    tags: ["时间循环", "高概念", "爽感"],
    popularity: 8460,
    releaseDate: "2024-02-19",
  },
];